/* Auto generated by gulp-typescript-template */

export const TagFilter = `<div class="tag-filter margin-box -v-medium"><div view="repeat" items="[[ tags ]]" as="tag" class="tag-list"><div view="Tag" data="[[ tag ]]" on-toggled="[[ parent.onToggle( tag ) ]]"></div></div></div>`;
